import React, { useState } from "react";
import { FaEnvelope, FaRegCopy, FaCheck, FaUserTie, FaBuilding, FaStore, FaClock } from "react-icons/fa";
import styles from "./ProgrammePage.module.css";

const ProgrammePage = () => {
    const [copied, setCopied] = useState(false);
    const email = "ivec2027@gmail.com";

    const handleCopy = () => {
        navigator.clipboard.writeText(email);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const committeeMembers = [
        { name: "Sushil Raina", title: "Technical Program Committee" },
        { name: "P. Raja Ramana Rao", title: "Technical Program Committee" },
    ];

    return (
        <div className={styles.pageContainer}>
            <div className={styles.contentWrapper}>

                {/* Header */}
                <header className={styles.header}>
                    <span className={styles.badge}>PROGRAMME</span>
                    <h1 className={styles.title}>Comming Soon</h1>
                </header>

                {/* Coming Soon Notice */}
                <div className={styles.comingSoonCard}>
                    <FaClock className={styles.clockIcon} />
                    <div className={styles.comingSoonContent}>
                        <p>
                            We are finalizing the technical sessions and programme details.
                            Please check back soon for the complete schedule.
                        </p>
                    </div>
                </div>

                {/* Query Banner Matching Image Design */}
                <div className={styles.queryBanner}>
                    <div className={styles.iconContainer}>
                        <FaStore className={styles.bannerIcon} />
                    </div>
                    <div className={styles.bannerContent}>
                        <h3 className={styles.bannerTitle}>
                            Any queries regarding the programme schedule or sessions may please be directed to:
                        </h3>

                        <div className={styles.bannerDetails}>
                            {committeeMembers.map((member, index) => (
                                <React.Fragment key={index}>
                                    <span className={styles.detailItem}>
                                        <FaUserTie className={styles.itemIcon} /> {member.name}
                                    </span>
                                </React.Fragment>
                            ))}

                            <span className={styles.detailItem}>
                                <FaBuilding className={styles.itemIcon} /> Technical Program Committee
                            </span>

                            <div className={styles.emailWrapper}>
                                <a href={`mailto:${email}`} className={styles.bannerEmail}>
                                    <FaEnvelope className={styles.itemIcon} /> {email}
                                </a>
                                <button
                                    type="button"
                                    onClick={handleCopy}
                                    className={styles.bannerCopyBtn}
                                    title="Copy email"
                                >
                                    {copied ? <FaCheck className={styles.checkIcon} /> : <FaRegCopy />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ProgrammePage;